import { getApi, OK} from "@/util";

const state = {
	apiStatus: null,
	groupData: null,
	groupId: null,
}

const mutations = {
	setApiStatus (state, status) {
		state.apiStatus = status
	},
	setGroupData(state, data) {
		let groups = []
		let default_group = []
		data.filter((item) => {
			if (item.default_flg === 0) {
				groups.push(item)
			}
			else {
				default_group.push(item)
			}
		})
		state.groupData = default_group.concat(groups)
	},
	setGroupId(state, data) {
		state.groupId = data
	},
}

const actions = {
	async groupApi(context) {
		context.commit('setApiStatus', null)
		const response = await getApi('group')

		// 正常処理
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			context.commit('setGroupData', JSON.parse(response.data).group_list)
			return false
		}

		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', response.message, { root: true })
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
